import React, {useMemo} from 'react'

import Task from "../../model2/task/task"
import FormRowFlex from "../../gd-form/form/form-flex/row"
import FormFlex from "../../gd-form/form/form-flex/form"
import FormModel from "../../gd-form/common/form-model-manager"
import FieldFormElement from "../../fields3/render/form-elemnent"
import FormFieldError from "../../gd-form/common/form-error/form-field-error"
import ButtonSubmit from "../../gd-form/common/btn-submit/btn-submit-ui5"
import ModalV4HeaderWhite from "../../../app/ui/modal/v4/header-white/v4-header-white"
import Reminder from "../../model2/reminder/reminer"
import ReminderFields from "../../model2/reminder/fields"

type Props = {
    params: {
        task    : Task,
        userId  : ID
    }
}

const debug = false
// const debug = "TaskReminderModal"

export default function TaskReminderModal(props:Props) {

    const stopPropagation = (e:React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
    }

    const closeModal = () => {
        gd.modal.hide()
    }

    const fields = useMemo(()=>new ReminderFields(props.params.task), [props.params.task])

    const model = useMemo(()=>new Reminder({
        userId: props.params.userId || props.params.task.actionRequiredUserId
    }), [props.params.task])

    const onSubmit = async (model: Reminder) => {
        debug && console.log(debug, 'onSubmit', model)

        await gd.api.Task.reminderCreate(props.params.task, model).promise()

        gd.modal.hide()
    }

    const form = new FormModel(model, {
        onSubmit        : onSubmit,
        isFormChanged   : true,
    })

    const labelWidth = 150

    return (
        <div className="v4-container placement-middle" onClick={stopPropagation}>
            <ModalV4HeaderWhite className       = "center-title p-t-60"
                                titleClassName  = "m-t-10"
                                height          = {90}
                                title           = "Create a Reminder"
                                onClose         = {closeModal}/>

            <FormFlex className="p-t-40 p-l-50 p-r-50 p-b-50">
                <FormRowFlex label={fields.title.label} width={labelWidth}>
                    <div className="flex-column-left-top">
                        <FieldFormElement className="w-300" field={fields.title} form={form}/>
                        <FormFieldError form={form} fieldId={fields.title.fieldId}/>
                    </div>
                </FormRowFlex>

                <FormRowFlex label={fields.userId.label} width={labelWidth}>
                    <div className="flex-column-left-top">
                        <FieldFormElement className="w-300" field={fields.userId} form={form}/>
                        <FormFieldError form={form} fieldId={fields.userId.fieldId}/>
                    </div>
                </FormRowFlex>

                <FormRowFlex label="Date" width={labelWidth}>
                    <div className="flex-column-left-top">
                        <FieldFormElement className="w-300" field={fields.date} form={form}/>
                        <FormFieldError form={form} fieldId={fields.date.fieldId}/>
                    </div>
                </FormRowFlex>

                <FormRowFlex className="m-t-30" width={labelWidth}>
                    <ButtonSubmit form={form} size="36" label="Submit"/>
                </FormRowFlex>
            </FormFlex>
        </div>
    )
}